module.exports = __webpack_public_path__ + "static/Earnin-eb044a4e25b73ba68fefb75a5644d15d.jpg";